import { Button, Result } from 'antd';
import { useNavigate } from "react-router-dom";

const NotFoundComponent = () => {

    const navigate = useNavigate();

    return (
        <Result
            status="404" 
            title="404"
            subTitle="Sorry, page  not found."
            extra={<Button type="primary" onClick={() => navigate(-1)}>Back Home</Button>}
        />
    )
}

export default NotFoundComponent